import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {MatchesTabModel} from "../matches.tab-model";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitionMatchesPageLinkModel} from "../../../../../containers/competition-container/pages/matches-page/models/competition-matches-page.link-model";

export class CompetitionMatchesPageTabModel extends MatchesTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel,
    isWidget: BaseLinkModel
  ) {
    super(index, name, isWidget)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionMatchesPageLinkModel {
    const linkModel: CompetitionMatchesPageLinkModel = new CompetitionMatchesPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, COMPETITION_CONTAINER.FILTERS.matches, null, this.entity.isFollow);

    //COMPETITION_CONTAINER.FILTERS.matches,this.isWidget ? super.itemHashParams(ENTITY_SCORES.URL_FILTERS.recentMatches) : super.itemHashParams(ENTITY_SCORES.URL_FILTERS.fixtures)
    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.matches;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_matches';
  }
}
